import { render, staticRenderFns } from "./AimingFor.vue?vue&type=template&id=63d3549a&"
import script from "./AimingFor.vue?vue&type=script&lang=ts&"
export * from "./AimingFor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63d3549a')) {
      api.createRecord('63d3549a', component.options)
    } else {
      api.reload('63d3549a', component.options)
    }
    module.hot.accept("./AimingFor.vue?vue&type=template&id=63d3549a&", function () {
      api.rerender('63d3549a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboards/columns/AimingFor.vue"
export default component.exports